import React from "react";
import { SITE, waLink } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = ({
  label = "WhatsApp",
  variant = "primary",
  message,
  className = "",
  testId = "wa-btn",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 rounded-none font-semibold tracking-wide transition-all duration-200 hover:-translate-y-0.5";
  const styles =
    variant === "primary"
      ? "bg-[#D4AF37] text-black hover:bg-[#C5A059]"
      : variant === "whatsapp"
      ? "bg-[#25D366] text-black hover:bg-[#1FB955]"
      : "bg-transparent border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10";

  return (
    <a
      data-testid={testId}
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${styles} ${className}`}
      aria-label={`Contactar por WhatsApp al ${SITE.whatsappDisplay}`}
    >
      <MessageCircle className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.2} />
      <span>{label}</span>
    </a>
  );
};

export default WhatsAppButton;
